import { inject, Injectable } from '@angular/core';
import { AuthService } from '../../../modules/auth/services/auth.service';
import { Permissions } from '../../../modules/auth/permissions/permissions';
import { VENDOR_NAVIGATION_ITEMS } from '../models/vendor-navigation-items';
import { DELIVERY_NAVIGATION_ITEMS } from '../models/delivery-navigation-items';
import { SUPER_ADMIN_NAVIGATION_ITEMS } from '../models/super-admin-navigation-items';
import { CUSTOMER_NAVIGATION_ITEMS } from '../models/customer-navigation-items';
import { NavigationGroup } from '../models/navigation-item.model';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {

  authService = inject(AuthService);

  getNavigationItems(): NavigationGroup[] {

    if (this.authService.hasPermission(Permissions.IS_VENDOR))
      return VENDOR_NAVIGATION_ITEMS;
    else if (this.authService.hasPermission(Permissions.IS_SUPER_ADMIN))
      return SUPER_ADMIN_NAVIGATION_ITEMS;
    else if (this.authService.hasPermission(Permissions.IS_DELIVERY_MANAGER))
      return DELIVERY_NAVIGATION_ITEMS;
    else if (this.authService.hasPermission(Permissions.IS_CUSTOMER))
      return CUSTOMER_NAVIGATION_ITEMS;

    return [];
  }
}
